// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import VueMq from 'vue-mq';
import LightTimeline from 'vue-light-timeline';
import BootstrapVue from 'bootstrap-vue';
// import VuetifulBoard from 'vuetiful-board';
import VueApexCharts from 'vue-apexcharts';
import EditorTinyMce from '@tinymce/tinymce-vue';
// import wysiwyg from 'vue-wysiwyg';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import VCalendar from 'v-calendar';
import HighchartsVue from 'highcharts-vue';
import VueCookies from 'vue-cookies';
import '@/themes/default/index.scss';
import '@/themes/default/no-touch-hover.scss';
import { VueMaskDirective } from 'v-mask';
// eslint-disable-next-line
import library from './fontAwesome';
import messages from './lang';
import App from './App';
import router from './router';
import store from './store';
// eslint-disable-next-line import/first
import AudioRecorder from 'vue-audio-recorder-x';

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;
Vue.use(VueI18n);
Vue.use(LightTimeline);
Vue.use(BootstrapVue);
Vue.use(VueApexCharts);
Vue.use(HighchartsVue);
Vue.directive('mask', VueMaskDirective);
// Vue.use(VuetifulBoard);

Vue.use(VCalendar, {
  componentPrefix: 'vc',
});
Vue.component('apexchart', VueApexCharts);

const i18n = new VueI18n({
  locale: store.state.settings.country,
  messages,
});

Vue.use(EditorTinyMce);
Vue.component('wysiwyg', EditorTinyMce);
Vue.use(VueMq, store.state.settings.breakpoints);
Vue.use(AudioRecorder);
Vue.use(VueCookies);

/* eslint-disable no-new */
new Vue({
  i18n,
  el: '#app',
  router,
  store,
  components: {
    App,
  },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js